import styles from "./HeaderPanel.module.scss";

type IHeaderPanel = {
  children: React.ReactNode;
};

export const HeaderPanel = ({ children }: IHeaderPanel) => {
  return <div className={styles.headerPanel}>{children}</div>;
};
